var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuymeacoffee(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFEB3B",
    d: "M7.58 23.5h8.781l2.894-17.678H4.684z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M16.786 24H7.155L4.096 5.322h15.748L16.786 24zm-8.782-1h7.932l2.73-16.678H5.273L8.004 23z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M20 5.822H4V3.299h16z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M20.5 6.322h-17V2.799h17v3.523zm-16-1h15V3.799h-15v1.523z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M6.975.5h9.938l1.198 2.8-12.334-.001z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M18.869 3.8 5.02 3.799 6.645 0h10.598l1.626 3.8zM6.535 2.799l10.819.001-.771-1.8H7.305l-.77 1.799z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "m4.29 10.3 15.311-.001-1.438 7.731H5.728z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#212121",
    d: "M18.579 18.53H5.312L3.689 9.8l16.514-.001-1.624 8.731zm-12.435-1h11.604L19 10.799 4.892 10.8l1.252 6.73z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuymeacoffee);
export default __webpack_public_path__ + "static/media/buymeacoffee.d198bb832afe09698d303b5eabf26158.svg";
export { ForwardRef as ReactComponent };